var map = {
	"./android-change-to-allow.png": 59595,
	"./android-lock-icon.png": 68276,
	"./android-select-permissions.png": 25343,
	"./android-select-required-permission.png": 6530,
	"./ios-aA-icon.jpeg": 4186,
	"./ios-allow.jpeg": 83564,
	"./ios-location.jpeg": 92442,
	"./ios-microphone.jpeg": 30761,
	"./ios-website-settings.jpeg": 76824,
	"./os-x-firefox-allow.png": 96942,
	"./os-x-firefox-preferences-icon.png": 78283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95884;